class ExternalFetchAll {
    constructor() {
        this.init();
    }

    init() {
        this.fetchData().then((data) => {
            document.querySelectorAll('[data-external-fetch-all]').forEach((el) => new ExternalFetchAllItem(el, data));
        });
    }

    fetchData() {
        const url = `/api/external/projects/`;
        return new Promise((resolve, reject) => {
            const cacheKey = `fetch_all`;
            const cachedData = sessionStorage.getItem(cacheKey);
            const now = Date.now();

            if (cachedData) {
                const parsedData = JSON.parse(cachedData);
                if (now - parsedData.timestamp < 5 * 60 * 1000) {
                    if (parsedData.data) {
                        resolve(parsedData.data);
                    } else {
                        resolve(null);
                    }
                    return;
                }
            }

            fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Error: ${response.status} - ${response.statusText}`);
                    }
                    return response.json();
                })
                .then(result => {
                    sessionStorage.setItem(cacheKey, JSON.stringify({ data: result.data, timestamp: Date.now() }));
                    resolve(result.data);
                })
                .catch(error => {
                    sessionStorage.setItem(cacheKey, JSON.stringify({ data: null, timestamp: Date.now() }));
                    resolve(null);
                });
        });
    }
}

class ExternalFetchAllItem {
    constructor(item, data) {
        this.createTime = item.dataset.externalFetchAllDate;
        this.item = item;
        this.data = data;
        this.findAndShow();
    }

    findAndShow() {
        const rawData = this.item.dataset.externalFetchAll;

        let versionsNames = [];
        if (rawData.startsWith('[')) {
            versionsNames = JSON.parse(rawData);
        } else {
            versionsNames.push(rawData);
        }

        if (!this.data) {
            this.displayEmpty();
            return;
        }

        const versions = this.data.filter((item) => versionsNames.includes(item.name_full));
        if (versions.length > 0) {
            this.displayData(versions[0]);
        } else {
            this.displayEmpty();
        }
    }

    displayData(data) {
        if (!data) {
            this.item.innerHTML = `<p class="error">No data found.</p>`;
            return;
        }

        var html = [];

        if (data.percentage_work_completed < 100) {
            html.push(`<div class="item-badges__item item-badges__item--primmary" style="--bg-color: #2d7903">Em progresso</div>`);
        } else if (data.percentage_work_completed >= 100) {
            html.push(`<div class="item-badges__item item-badges__item--primmary" style="--bg-color: #000000">Concluído</div>`);
        }

        if (data.percentage_paid < 100) {
            html.push(`<div class="item-badges__item item-badges__item--secondary" style="--bg-color: #bf0003">Aguardar pagamento</div>`);
        } else if (data.percentage_paid >= 100) {
            html.push(`<div class="item-badges__item item-badges__item--secondary" style="--bg-color: #000000">Pago</div>`);
        }

        this.item.innerHTML = html.join('');
    }

    displayLoading() {
        this.item.innerHTML = `<div class="item-badges__item item-badges__item--secondary" style="--bg-color: #000000">A carregar...</div>`;
    }

    displayEmpty() {
        // Check if createTime exists and is before 2025
        if (this.createTime) {
            const createTimeYear = new Date(this.createTime).getFullYear();
            if (createTimeYear < 2025) {
                this.item.innerHTML = `<div class="item-badges__item item-badges__item--primmary" style="--bg-color: #000000">Concluído</div>`;
                return;
            }
        }
        console.log("No createTime or createTime is 2025 or later");
        this.item.innerHTML = ``;
    }
}

export default ExternalFetchAll;